<template>
  <div class="home-layout-footer">
    <div class="tab-list">
      <div
        class="tab-item"
        :class="selectClass($route.name, 'nft')"
        @click="toggleTab('nft')"
      >
        <nft-app-svg />
        <div class="tab-name">{{ $t("footerMenu.nft") }}</div>
      </div>
      <div
        class="tab-item"
        :class="selectClass($route.name, 'search')"
        @click="[toggleTab('search'), initSearch()]"
      >
        <search-svg class="search-svg" />
        <div class="tab-name">{{ $t("footerMenu.search") }}</div>
      </div>
      <div
        class="tab-item scan-tab"
        @click="$router.push({ name: 'QrScanView' })"
      >
        <div class="scan-button">
          <img src="@/assets/images/icons/scan_outline.svg" />
        </div>
        <div class="tab-name">{{ $t("footerMenu.scan") }}</div>
      </div>
      <div
        class="tab-item"
        :class="selectClass($route.name, 'coupon')"
        @click="toggleTab('coupon')"
      >
        <ticket-svg class="coupon-svg" />
        <div class="tab-name">{{ $t("footerMenu.coupon") }}</div>
      </div>
      <div
        class="tab-item"
        :class="selectClass($route.name, 'profile')"
        @click="toggleTab('profile')"
      >
        <profile-svg class="profile-svg" />
        <div class="tab-name">{{ $t("footerMenu.profile") }}</div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NftAppSvg from "@/components/svg/NftAppSvg.vue";
import ProfileSvg from "@/components/svg/ProfileSvg.vue";
import SearchSvg from "@/components/svg/SearchSvg.vue";
import TicketSvg from "@/components/svg/CouponSvg.vue";
import { useHomeListConfig } from "@/script/homeScript";
import router from "@/router";
import { useRoute } from "vue-router";
import { store } from "@/store";

export default defineComponent({
  name: "HomeLayoutFooter.vue",
  components: {
    NftAppSvg,
    ProfileSvg,
    SearchSvg,
    TicketSvg,
  },
  setup() {
    const { toggleViewMode, toggleButtonText } = useHomeListConfig();

    const route = useRoute();

    const routeInfo = {
      nft: {
        routeName: ["HomeView", "BrandCltnListView"],
      },
      search: {
        routeName: ["DiscoverView"],
      },
      coupon: {
        routeName: ["CouponListView"],
      },
      profile: {
        routeName: ["MyProfileView"],
      },
    };

    type TabName = keyof typeof routeInfo;

    const toggleTab = (tabName: TabName) => {
      router.push({ name: routeInfo[tabName].routeName[0] });
    };

    const selectClass = (routeName: string, tabName: TabName) => {
      if (routeInfo[tabName].routeName.includes(routeName))
        return "tab-selected";
    };
    const initSearch = () => {
      if (route.name === "SearchView") {
        return;
      } else {
        store.commit("search/INIT_SEARCH", null);
      }
    };

    return {
      toggleViewMode,
      toggleButtonText,
      toggleTab,
      selectClass,
      initSearch,
    };
  },
});
</script>
